<template>
  <div id="scmenu">
    <div>
      <div class="menubutton_wrapper">
        <!-- <div class="menubutton" @click="hidemenu"> -->
        <div class="menubutton" @click="togglemenu">
          <i  class="fa fa-bars" aria-hidden="true"></i>
        </div>
        <a href="/"><img v-if="largescreen===false" src="/assets/img/sslogo.svg" alt="スカンジナビアサービス"></a>
      </div>
      <!-- <div v-show="largescreen" id="app" class="horizontal-logo"> -->
      <div v-if="largescreen===true" class="horizontal-logo">
        <!-- <router-link to="/"><img src="/assets/img/sslogo.svg"></router-link> -->
        <a href="/"><img src="/assets/img/sslogo.svg" alt="スカンジナビアサービス"></a>
      </div>
      <p style="padding-top:48px;">　</p>

      <!-- <div @click="gohome">
           <section class="faq_contact_recruit-section">
           <nav id="faq_contact_recruit-nav" class="faq_contact_recruit" role="navigation"> -->
            <!-- <div @click.stop="gotofaq">
                 <a href="/faq">よくあるご質問<span>FAQ</span></a>
                 </div>
                 <div  @click.stop="gotocontact">
                 <a href="/contact">問い合わせ<span>Contact</span></a>
                 </div>
                 <div @click.stop="gotoinstagram">
                 <a href="https://www.instagram.com/scandinavia_service/"><i class="fab fa-instagram"></i><span>Instagram</span></a>
                 </div> -->
            <!-- <div v-if="!isLoggedIn" @click.stop="gotologin">
                 <a href="/login">ログイン<span>Login</span></a>
                 </div>
                 <div v-if="isLoggedIn" @click.stop="logout">
                 <a>ログアウト<span>Logout</span></a>
                 </div>
                 <div v-if="isLoggedIn" @click.stop="userpage">
                 <a href="/userpage">会員様ページ<span v-if="largescreen===true">{{user.email}}</span></a>
                 </div> -->
      <!-- </nav>
           </section>
           </div> -->


    </div>
    <div class="centered">
      <section class="menu-section" v-show="showMenu">
        <nav id="single-nav" class="single-nav menu" role="navigation">
          <ul>
            <!-- <li><router-link to="/products">商品案内<span>Products</span></router-link></li> -->
            <li><a href="/products">商品案内<span>Products</span></a></li>
            <!-- <li><router-link to="/support">サポート<span>Support</span></router-link></li> -->
            <li><a href="/support">サポート<span>Support</span></a></li>
            <!-- <li><router-link to="/kaisha">会社概要<span>Company Profile</span></router-link></li> -->
            <li><a href="/kaisha">会社概要<span>Company Profile</span></a></li>
            <!-- <li><router-link to="/catalog">広告・カタログ<span>Advertisements</span></router-link></li> -->
            <!-- <li><a href="/catalog">広告・カタログ<span>Advertisements</span></a></li> -->
            <!-- <li><router-link to="/news">ニュース<span>News</span></router-link></li> -->
            <!-- <li><a href="/news">ニュース<span>News</span></a></li> -->
            <!-- <li><router-link to="/taiken">無料体験<span>Free Trial</span></router-link></li> -->
            <li><a href="/taiken">無料体験<span>Free Trial</span></a></li>
            <!-- <li><router-link to="/BeautySpecialistAward">フォトコンテスト<img src="/assets/img/new004_01.gif" class="new-gif"><span>Beauty Specialist Award</span></router-link></li> -->
            <!-- <li><router-link to="/monitortouroku">モニター募集<img src="/assets/img/new004_01.gif" class="new-gif"><span>Monitor</span></router-link></li> -->
            <!-- <li><a href="https://scan2021.theshop.jp/">オンラインストア<img src="/assets/img/new004_01.gif" class="new-gif"><span>Online Store</span></a></li> -->
            <!-- <li><router-link to="/onlinestore">オンラインストア<img src="/assets/img/new004_01.gif" class="new-gif"><span>Online Store</span></router-link></li> -->
            <li><a href="/onlinestore">オンラインストア<span>Online Store</span></a></li>
            <li><a href="/faq">よくあるご質問<span>FAQ</span></a></li>
            <li> <a href="/contact">問い合わせ<span>Contact</span></a></li>
            <!-- <li><a href="https://www.instagram.com/scandinavia_service/"><i class="fab fa-instagram"></i><span>Instagram</span></a></li> -->
            <li><a href="/en">English<span>英語</span></a></li>
            <!-- <li><a href="/saiyo">採 用<span>Recruit</span></a></li> -->
          </ul>
        </nav>
      </section>
    </div>
    <div class="menu-back">
    </div>
  </div>
</template>
<script>
 import firebase from 'firebase/app';
 import 'firebase/auth';
 import 'firebase/firestore';
 import { mapGetters } from 'vuex'
 export default {
   name: 'scMenu',
   props: {
     largescreen: {
       type: Boolean
     }
   },
   data () {
     return {
       windowWidth: 0,
       isLoggedIn: false,
       currentUser: false,
       showMenu: 'false',
       locallargescreen: 'true'
     }
   },
   updated() {
     this.$nextTick(function () {
       // Code that will run only after the
       // entire view has been re-rendered
       if (this.largescreen) {
         this.locallargescreen = true;
         this.showMenu = true;
       }
       console.log(`updated: largescreen is ${this.largescreen}`);
       console.log(`updated: locallargescreen is ${this.locallargescreen}`);
       console.log(`updated: showMenu is ${this.showMenu}`);

     })
   },
   created() {
     if (firebase.auth().currentUser) {
       this.isLoggedIn = true;
       this.currentUser = firebase.auth().currentUser.email;
       /* this.$store.commit( 'user', firebase.auth().currentUser) */
     }

     console.log(`created: largescreen is ${this.largescreen}`);
     console.log(`created: showMenu is ${this.showMenu}`);
   },
   mounted() {
     this.windowWidth = window.innerWidth;
     if (this.windowWidth < 600) {
       this.locallargescreen = false;
     };
     console.log(`mounted: largescreen is ${this.largescreen}`);

     /*
        At startup on small screens we want to hide menu-section (i.e the drop down menu).
        'largescreen' is true even in small screens here (at mounted).
        It becomes false after this from App.vue. (see console)
        So use window.innerWidth and make our own largescreen named locallargescreen.
        And set showMenu according to locallargescreen
      */

     console.log(`mounted: windowWidth is ${this.windowWidth}`);
     console.log(`mounted: locallargescreen is ${this.locallargescreen}`);

     if (this.locallargescreen) {
       this.showMenu = true;
     } else {
       this.showMenu = false;
     }
     console.log(`mounted: showMenu is ${this.showMenu}` );
   },
   computed: {
     ...mapGetters([
       'user'
       // ...
     ])

   },
   methods: {
     togglemenu() {
       this.showMenu = !this.showMenu
       console.log(`togglemenu: showMenu is ${this.showMenu}`);
     },
     gohome() {
       window.location.href = "/"
     },
     gotofaq() {
       this.$router.push('faq')
     },
     gotocontact() {
       this.$router.push('contact')
     },
     gotosaiyo() {
       this.$router.push('saiyo')
     },
     gotologin() {
       this.$router.push('login')
     },
     userpage() {
       this.$router.push('userpage')
     },
     logout: function() {
       firebase
         .auth()
         .signOut()
         .then(() => {
           this.$store.commit( 'user', false )
           /* this.$router.go({ path: this.$router.path }); */
           this.$router.push( this.$route.query.redirect ? this.$route.query.redirect :  window.location.href = "/" )
         });
       this.isLoggedIn = false;
       this.currentUser = false;
     },
     gotoinstagram() {
       window.location.href = "https://www.instagram.com/scandinavia_service/"
     },
     gotofacebook() {
       window.location.href = "https://www.facebook.com/Scandinavia-Service-195006417813381/"
     }
   }
 }
</script>

<style lang="scss" scoped>
 $dropdownmenu-bgcolor: #aaa;
 $menutype-color: #555;
 $menutype-color-eng: $dropdownmenu-bgcolor;
 $page-width: 960px;
 .new-gif {
   width: 24px;
 }
 a {
   cursor: pointer;
 }
 .horizontal-logo {
   cursor: pointer;
   display: flex;
   // background: #ddd;
   width: $page-width;
   justify-content: center;
   // justify-content: flex-start;
   // center .horizontal-logo to page
   // https://cotodama.co/position-absolute-center/
   position: absolute;
   left: 0;
   right: 0;
   top: 22px;
   margin: auto;
   img {
     // display: block;
     width: 270px;
   }
 }

 // dropdown menu section
 .menu li a {
   padding-left: 15px;
   padding-right: 15px;
 }
 .menu li a img{
   margin-top: -5px;
 }
 .menubutton_wrapper {
   display: flex;
   // justify-content: space-between;
   align-items: center;
   .menubutton {
     margin-top: 5px;
     margin-bottom: 5px;
     font-family: sans-serif;
     font-size: 30px;
   }
   img {
     display: block;
     margin-right: 10px;
     width: 250px;
   }
 }
 @media (min-width: 601px) {
   .menubutton {
     display: none;
   }
 }
 @media screen and (max-width: 1450px) {
   .horizontal-logo {
     /* stop it from colliding with faq_contact_recruit */
     justify-content: flex-start;
     margin-left: 15px;
   }
 }
 @media (max-width: 600px) {
   .menubutton {
     margin: 0 auto;
     margin-top: 5px;
     margin-bottom: 5px;
     margin-left: 10px;
     font-family: sans-serif;
     font-size: 30px;
   }
   .menu-section {
     width: 100%;
     background-color: #fff;
     opacity: 0.95;
     font-size: 1.0em;
     margin-top: -70px;
     filter: drop-shadow(5px 5px 5px rgba(0,0,0,0.2));
   }
   .menu li a {
     margin-left: 30px;
   }
 }

 .hide {
   /* display: none; */
 }

 .faq_contact_recruit-section {
   // without this, horizontal-logo overlaps above the faq button and the latter doesn't function
   position :relative;
 }
 #faq_contact_recruit-nav {
   display: inline-block;
   // background-color: #ddd;
   width: 100%;
   display: flex;
   justify-content: flex-end;
 }

 .faq_contact_recruit {
   font-size: 0.8em;
   color: $menutype-color;
   margin: 20px 0 20px 0;
   div {
     display: flex;
     justify-content: center;
     /* flex: 0 0 auto; */
     padding: 0 10px;
     // background: #eee;
     border-right: 1px solid #999;
     a {
       text-align: center;
       i {
         font-size: 16px;
       }
     }
   }
   div:last-of-type {
     border-right: none;
   }
   span {
     display: block;
     font-size: 70%;
     font-weight: lighter;
     font-style: italic;
     color: $menutype-color-eng;
   }
 }
 @media (max-width: 600px) {
   .faq_contact_recruit {
     font-size: 0.8em;
     color: $menutype-color;
     // margin: 20px 0 20px 0;
     div {
       display: flex;
       justify-content: center;
       flex: 1;
       padding: 2px;
       // background: #eee;
       border-right: 1px solid #999;
       a {
         text-align: center;
       }
     }
   }
 }
</style>
